import * as React from 'react';

import { ShimmerText } from '../../Shimmer';
import { FilterItem, FilterItemInformation } from '../FiltersList.styles';

const ShimmerFilterComponent = () => {
  return (
    <FilterItem>
      <ShimmerText $width="1.25rem" $height="1.25rem" />
      <FilterItemInformation>
        <ShimmerText $width="6.812rem" $height="0.813rem" />
        <ShimmerText $width="4.75rem" $height="0.75rem" $marginTop="0.625rem" />
      </FilterItemInformation>
    </FilterItem>
  );
};

export default ShimmerFilterComponent;
